// The visitor's cookie choice. Analytics cookies run unless it is "denied", except in the
// EU/EEA, where they wait for "granted". Until a choice is stored the banner shows.
// The choice lives in localStorage, which needs no consent itself.

export type Consent = "granted" | "denied";

const KEY = "monet-cookie-consent";
const OPEN_EVENT = "monet:cookie-settings";

export const readConsent = (): Consent | null => {
  try {
    const v = window.localStorage.getItem(KEY);
    return v === "granted" || v === "denied" ? v : null;
  } catch {
    return null;
  }
};

export const writeConsent = (value: Consent) => {
  try {
    window.localStorage.setItem(KEY, value);
  } catch {}
};

// EU member states plus Iceland, Liechtenstein and Norway (EEA), which follow the same rules.
const OPT_IN = new Set([
  "AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "DE", "GR", "HU", "IE",
  "IT", "LV", "LT", "LU", "MT", "NL", "PL", "PT", "RO", "SK", "SI", "ES", "SE",
  "IS", "LI", "NO",
]);

/** True when analytics must wait for Accept. An unknown country counts as opt-in, to be safe. */
export const needsOptIn = async (): Promise<boolean> => {
  try {
    const { country } = await (await fetch("/api/geo")).json();
    return !country || OPT_IN.has(country);
  } catch {
    return true;
  }
};

/** Reopens the banner, e.g. from the footer's Cookies link. */
export const openCookieSettings = () => window.dispatchEvent(new Event(OPEN_EVENT));

export const onOpenCookieSettings = (fn: () => void) => {
  window.addEventListener(OPEN_EVENT, fn);
  return () => window.removeEventListener(OPEN_EVENT, fn);
};
